module.exports = __webpack_public_path__ + "src/app/assets/images/pip.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/pip.png
// module id = 628
// module chunks = 0